import { render, staticRenderFns } from "./BasePrimaryActionButton.vue?vue&type=template&id=1b96ed0e&scoped=true&"
import script from "./BasePrimaryActionButton.vue?vue&type=script&lang=js&"
export * from "./BasePrimaryActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96ed0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VIcon,VScaleTransition})
